module.exports = __webpack_public_path__ + "img/button_exchange.08c69692.png";